import { combineReducers } from "redux";
import blogReducer from "./blogPosts/blogReducer";
import filterReducer from "./filters/filterReucer";

const rootReducer = combineReducers({
  blogPosts: blogReducer,
  filters: filterReducer,
});

export default rootReducer;
